import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=b79d1f96&scoped=true&"
import script from "./Placeholder.vue?vue&type=script&lang=js&"
export * from "./Placeholder.vue?vue&type=script&lang=js&"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=b79d1f96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d1f96",
  null
  
)

export default component.exports